﻿export enum ModelChangeType
{
    Create, Update, Delete
}

export class ModelChange<T>
{
    public ChangeType: ModelChangeType;
    public Value: T;
}